import React from "react";
import { FaArrowRight } from "react-icons/fa6";

const CustomButton = ({
  text, // text need to put here
  bgColor = "#d31c4f", //background need to put here by default
  width = "fit", // by default fit
  handleClick, // for handling the click functionality
  marginX, //for giving margin like when we want to put in center
  marginY = "20px", // for giving margin y ,
  paddingX = "16px", // for giving padding x by default 16px
  paddingY = "10px", // for giving padding y by default 8px
  marginTop = "20px",
  disabled = false,
  icon=true,
  customIcon=<FaArrowRight className="inline ml-[6px]"/>
}) => {
  return (
    <button
      disabled={disabled}
      onClick={handleClick}
      className="bg-[#D31C4F] cursor-pointer flex font-medium z-30 items-center justify-center font-Lato text-base rounded-xl text-sky-50"
      style={{
        backgroundColor: bgColor,
        marginTop: marginTop,
        width: width,
        margin: `${marginY} ${marginX}`,
        padding: `${paddingY} ${paddingX}`,
      }}
    >
      {text} {icon && customIcon} 
    </button>
  );
};
 
export default CustomButton;
